module.exports = __webpack_public_path__ + "img/English-09.094c48bf.jpg";